<template>
  <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      d="M21.64,7.85H2.37v2.75h19.27v-2.75ZM.99,6.47v5.51h22.02v-5.51H.99Z"
      fill="currentColor"
      fill-rule="evenodd"
    />
    <path
      d="M20.72,11.98H3.28v10.55h17.43v-10.55h0ZM1.91,10.6v13.31h20.19v-13.31s-20.19,0-20.19,0Z"
      fill="currentColor"
      fill-rule="evenodd"
    />
    <path d="M11.08,7.39v16.52h-1.38V7.39h1.38Z" fill="currentColor" fill-rule="evenodd" />
    <path d="M14.26,7.39v16.52h-1.38V7.39h1.38Z" fill="currentColor" fill-rule="evenodd" />
    <path
      d="M15.59,1.47c-.06,0-.25,0-.61.22-.5.29-1.08.87-1.56,1.7-.48.83-.69,1.61-.7,2.2,0,.42.08.59.12.63.06,0,.25,0,.61-.22.5-.3,1.08-.87,1.56-1.7s.69-1.62.7-2.2c0-.41-.08-.58-.12-.63ZM16.2,5c1.14-1.97,1.17-4.09.08-4.73-1.1-.63-2.91.45-4.06,2.43-1.15,1.98-1.17,4.09-.07,4.73,1.09.63,2.91-.45,4.05-2.43Z"
      fill="currentColor"
      fill-rule="evenodd"
    />
    <path
      d="M8.26,1.47c-.04.06-.12.22-.12.64,0,.58.22,1.38.7,2.2.48.83,1.06,1.4,1.56,1.7.36.21.55.22.61.22.04-.06.12-.22.12-.63,0-.58-.22-1.38-.7-2.2s-1.06-1.4-1.56-1.7c-.36-.22-.54-.23-.61-.23ZM11.62,2.7C10.48.73,8.66-.35,7.57.28c-1.1.63-1.06,2.74.07,4.73,1.13,1.99,2.95,3.06,4.06,2.43,1.09-.64,1.06-2.75-.08-4.73h0Z"
      fill="currentColor"
      fill-rule="evenodd"
    />
  </svg>
</template>
